import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function WordpressDevelopment() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/wordpressdev.jpg)` }}>
        </div>


        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>
            <h1>WordPress <br /> Development</h1>
            <p style={{ marginBottom: '3.5rem' }}>WordPress is arguably the most-used and most popular content management system (CMS) because of its incredible flexibility, easy-to-use interface, and SEO friendly structure. It allows a professional developer to build and manage websites cost-effectively, with rich features and functionality.</p>
            <h3>Custom-Designed WordPress Websites for Ultimate Customization & Versatility</h3>
            <p style={{ marginBottom: '3.5rem' }}>At YGS Web Solutions, our experienced and agile team of WordPress designers and developers has the deep knowledge and first-hand experience of developing winning websites, with custom design and features integration to suit various project requirements. We create mobile responsive, Google-friendly WordPress sites that provide an outstanding user experience, with stunning design, intuitive navigation, and ease of accessibility to information.</p>
            <p style={{ marginBottom: '3.5rem' }}>Custom WordPress design and development can make the difference between having an ordinary website and having a highly engaging and successful website. Our expert team creates impressive, responsive websites that will impress your audiece, regardless of device and screen size.</p>
            <h3>Wordpress Website Features</h3>
            <p style={{ marginBottom: '3.5rem' }}>Our WordPress solutions offer a complete complement of services, including web design and development, SEO optimization, maintenance and support, and marketing. We cover all of the following features in our WordPress Development service:</p>
            <ul style={{ listStyleType: 'square' }}>
              <li>Contemporary custom design</li>
              <li>Fully functional development</li>
              <li>Responsive on all devices</li>
              <li>Social media integration</li>
              <li>Client-specific custom functionality</li>
              <li>Google-friendly site structure</li>
              <li>SEO readiness</li>
              <li>Easy-to-manage backend</li>
              <li>High scalability and flexibility</li>
            </ul>
            <p style={{ marginBottom: '3.5rem' }}>Our WordPress development services ensure that your website is search engine friendly in its structure and provides a great user experience at all levels. Your feature-rich website will be easily expandable and will work and grow with your business as a high-performing foundation for your marketing efforts.</p>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/f4ec6f97843258fdb1605f75e0ebcf2de83d7fbe-581x552.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default WordpressDevelopment